import React from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import SvgChevronIcon from 'src/assets/chevron-icon';

export function BackButton({ backRoute, className }: { backRoute?: string | null; className?: string }): JSX.Element {
  const router = useRouter();
  return (
    <BackButtonContainer onClick={() => (backRoute ? router.push(backRoute) : router.back())} className={className}>
      <StyledSvgChevronIcon width={20} height={20} color='black' />
    </BackButtonContainer>
  );
}

const BackButtonContainer = styled.button`
  position: absolute;
  z-index: 10;
  top: 36px;
  left: 36px;
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 800px;

  background: ${({ theme }) => theme.colors.grey[95]};
  border: none;
  cursor: pointer;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.2);
`;

const StyledSvgChevronIcon = styled(SvgChevronIcon)`
  transform: rotate(90deg);
  color: ${({ theme }) => theme.colors.black};
`;
